module.exports = __webpack_public_path__ + "img/auxiliary-img-1.8801542b.gif";